export default {
	home: 'Home',
	invoice: 'invoice',
	patients: 'Patients',
	doctors: 'Doctors',
	stock: 'Stock',
	services: 'Services',
	settings: 'Settings',
	contact: 'Contact',
	new_invoice: 'New Invoice',
	detail_invoice: 'Detail Invoice',
	logout: 'Logout',
	kk1: 'Deer',
	kk2: 'Gourd',
	kk3: 'Rooster',
	kk4: 'Lobster',
	kk5: 'Crab',
	tsOdd: 'ODD',
	tsEven: 'Even',
	ts1: '1',
	ts2: '2',
	ts3: '3',
	ts4: '4',
	ts5: '5',
	ts6: '6',
	tsBig: 'O',
	tsSmall: 'U',
	kk6:'Fish'
};
